export default __webpack_public_path__ + "static/media/ts-4-2.47a1b271.svg";